module.exports = __webpack_public_path__ + "img/detallecurso7.896cf9a0.png";